import React, { useEffect, useState, useCallback } from 'react';
// import { Navbar, NavbarBrand,Row,Breadcrumb,BreadcrumbItem } from 'reactstrap';
import { useSelector, useDispatch } from 'react-redux';
// import { useHistory } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { VscSettingsGear } from "react-icons/vsc";

import getDt, { getDtfrmt } from '../../utils';
import { switchPkgTags, updTagAct, hidePkgNav } from '../redux/project/projActions';
import { resetUpdTag, hidePkgsAct, assignTags, hideTags } from '../redux/ctrl/ctrlActions';
import './index.scss'
import { TagDetails } from '../tags/TagDetails';
import treeViewCollapse from '../../assets/svg/Tree_view_collapse.svg';
import AppBar from '@mui/material/AppBar';
import { Typography, Box, Tab, IconButton } from "@mui/material";
import DynamicBreadcrumbs from '../shared/DynamicBreadcrumbs';
import { AgGridReact } from 'ag-grid-react';
import "@ag-grid-community/core/dist/styles/ag-grid.css";
import "@ag-grid-community/core/dist/styles/ag-theme-alpine.css";
import 'ag-grid-enterprise';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
// -------dragger package
import ViewDrawer from "../tags/viewDrawer";
import Draggable from "react-draggable";
import ConfigDetTagTree from './configDetTagTree';
// import configDetGrid from './configDetGrid';
import Grid from '@mui/material/Grid';
import ButtonC from '../shared/ButtonC';
import HOC from '../HOC/HOC';
import toastr from 'toastr';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import ConfigDetGrid from './configDetGrid';
import { spacing } from '@mui/system';
import Loader from '../loader';
import { useTranslation } from 'react-i18next';
import { FaAnglesRight } from 'react-icons/fa6';

const disb = false;
const ConfigDetails = () => {
  // let history = useHistory();
  let navigate = useNavigate();
  let ctrlState = useSelector((state) => state.ctrl)
  const tagColDefns = ctrlState.colDefns;
  const prof = useSelector((state) => state.profile)
  const [load, setLoad] = useState(true);
  const { t, i18n } = useTranslation();
  const [conFilValue, setConFilValue] = useState([{
    tag_number: "tag3",
    en_technology_type: "DP Flow",
  },
  {
    tag_number: "tag4",
    gen_technology_type: "Test1",
  },
  {
    tag_number: "tag5",
    gen_technology_type: "Flow",
  }]);
  const [gridApi, setGridApi] = useState(null);
  const dispatch = useDispatch();
  let pl = {};
  const BtnC = useCallback(HOC(ButtonC, disb), []);
  const [showCollapse, setShowCollapse] = useState(true);
  const [selectedTag, setSelectedTag] = useState("");
  const [findTag, setFindTag] = useState('');
  const handleSearch = (value) => {
    setFindTag(value)
  }


  const onGridReady = (params) => {
    setGridApi(params.api);
  }

  const navHome = () => {
    // history.push("/")
    dispatch(hideTags());
    dispatch(hidePkgsAct());
    dispatch(hidePkgNav());

    navigate("/")
  }

  /*useEffect(
      ()=> window.location.href ='http://prjwspgapis.azurewebsites.net/docs'
  )*/
  const navPkgs = () => navigate("/pkgs");
  const navTags = () => navigate("/tags", { replace: true });

  // const onSetShowCollapse = (val) => {
  //     const cnextP = document.getElementById('cnextP');

  //     // if(val){
  //     //     cnextP.style.width = '100%';
  //     // }else{
  //     //     cnextP.style.width = '78%';
  //     // }
  //     setShowCollapse(!val);
  // }
  const [positionFirst, setPositionFirst] = useState({ positionFirstX: 0 });
  // const [sidebarState, setSidebarState] = useState(true);
  const [sidebarState] = useState(true);
  const [activeTab, setActiveTab] = useState('1');

  const styleSidebar = {
    width: positionFirst.positionFirstX + 250,
    transition: '.1s ease-in-out'
  };
  const onSetShowCollapse = (val) => {
    console.log(val);
    if (!val) setPositionFirst({ positionFirstX: 0 })

    setShowCollapse(val)
  }

  const configLine = () => {
    // gridApi.stopEditing()
    // let selectedNodes = gridApi.getSelectedNodes();
    // let selectedData = selectedNodes.map(node => node.data);
    // if (selectedData.length == 0) {
    //   toastr.error('Please select the tag line')
    // }
    // else if (selectedData[0].gen_base_model_1 === null || selectedData[0].gen_base_model_1 === undefined) {
    //   toastr.error('Please select Base Model 1')
    // }
    // else {
    //   localStorage.setItem('TAG', selectedData[0].tag_number)
    //    dispatch(assignTags(selectedData[0], gridApi.getColumnDefs()))
    //   //gridApi.refreshCells();                 
    //   //console.log(selectedNodes)
    //   // history.push('/config')
    //   navigate('/config')
    // }
    navigate('/config')
  }

  const onDragFirst = (e, data) => {
    if (data.x > 0 && data.x <= 250) {
      setPositionFirst({ positionFirstX: data.x })
    }
  };
  return (
    <>
      {/* <configDetGrid selectedTag={selectedTag}/> */}
      <Loader />
      <AppBar id="tagsNavbar">
        <Grid>
          <Grid style={{ marginLeft: '10px' }}>
            <div>
              <h6 style={{ marginTop: "3px" }}>
                {(ctrlState.data.project_name?.length > 30
                  ? ctrlState.data.project_name.substr(0, 29) + "..."
                  : ctrlState.data.project_name) +
                  " - " +
                  (ctrlState.data.project_number?.length > 30
                    ? ctrlState.data.project_number.substr(0, 29) + "..."
                    : ctrlState.data.project_number)}
              </h6>
            </div>
            <div style={{ fontSize: "14px" }}>
              <DynamicBreadcrumbs onHome={navHome} onPackages={navPkgs} onTags={navTags} />
            </div>
          </Grid>
          <Grid item md={80} sm={8} xs={8}>



            <div className='d-flex'>
              <div className="ml-auto rt-actions d-flex" style={{ marginTop: '-2.3%' }}>
                <div>
                  {/*<Button className="sbtn0"/*className="cmnbtn"*//* id='crPkgId' onClick={() => { dispatch(crPkgAct())}} > +Create Package</Button>*/}
                  {/* <BtnC className="btn sbtn0 success-btn" id='reconfigure'  label='Reconfigure' onClick={configLine}/> */}
                  {/*<label htmlFor='crPkgId'> <AiOutlinePlusCircle className="cmnbtn1" data-toggle="tooltip" data-placement="top" title="Create Package"/> </label>*/}
                </div>

                {/* <div>
                    <SettingsMenu />
                </div> */}
              </div>
            </div>
          </Grid>
        </Grid>
      </AppBar>

      {/* <Navbar id='tagsNavbar'>
            <NavbarBrand>
                <Row>
                    <h6 style={{marginTop:'-10px'}}>{ctrlState.data.project_name +' - '+ ctrlState.data.project_number}</h6>
                </Row>
                <Row style={{fontSize:'14px'}}>
                    <Breadcrumb>
                        <BreadcrumbItem onClick={ ()=>navHome() }>Projects</BreadcrumbItem>
                        <BreadcrumbItem onClick={ ()=>navPkgs()}>Packages</BreadcrumbItem>
                        <BreadcrumbItem onClick={ ()=>navTags()}>Tag Workspace</BreadcrumbItem>
                        <BreadcrumbItem>Configurator</BreadcrumbItem>
                    </Breadcrumb>
                </Row>                  
            </NavbarBrand>
        </Navbar>           */}

      {/*<iframe src  = 'http://localhost:8000/cnext/'    id='cnext' name='cnext' width="100%"  height="550" onLoad={() => onObjLoad() }/>*/}
      <div className="mp-zero draggableHide size-mr"
        style={{ display: "flex", height: "93%" }}>

        {showCollapse &&
          <>
            <div
              className={'sidebar'}
              style={styleSidebar} >
              <ConfigDetTagTree
                configFilter={conFilValue}
                slctRev={1}
                setShowCollapse={setShowCollapse}
                setFindTag={handleSearch}
                setSelectedTag={setSelectedTag}
              />
            </div>
            {/* for draggable sidebar */}
            <Draggable
              defaultPosition={{ x: 0, y: 0 }}
              position={{ x: positionFirst.positionFirstX }}
              onDrag={onDragFirst}
            >
              <div>
                <ViewDrawer cssDrawer="drawerFirst" cssHandle="handleFirst" />
              </div>
            </Draggable>
          </>

        }
        {!showCollapse &&
          <div style={{ marginTop: 5 }}>
            {/* <img 
                    src={treeViewCollapse} 
                    style={{transform:'rotate(180deg)',cursor:'pointer'}} 
                    onClick={()=>onSetShowCollapse(true)} /> */}
            <IconButton sx={{ marginTop: '10px' }} onClick={() => onSetShowCollapse(true)} size='small' >
              <FaAnglesRight />
            </IconButton>
          </div>
        }
        {/* <   className="mp-zero flex-grow-1 position-relative">
            <div className="draggable-iframe-cover" ></div>
               <h1>GRID Hey {selectedTag.tag_number}</h1> */}

        <div className="mp-zero flex-grow-1 position-relative">
          <div className="draggable-iframe-cover"></div>
          <Box sx={{ p: '9px' }}>
            <TabContext value={activeTab}>
              <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                <TabList className="tab-height">

                  <Tab
                    label={t('Model String Breakdown')}

                    value="1"

                    onClick={() => setActiveTab("1")}

                  />

                  <Tab
                    label={t('Configuration Details')}
                    disabled={true}
                    value="2"

                    onClick={() => setActiveTab("2")}

                  />
                </TabList>
              </Box>
              {/* <TabPanel value="1">

<Grid container spacing={1.4}>
   <h1>Tab-1 {selectedTag.tag_number}</h1>

 </Grid>
</TabPanel> */}



              <TabPanel value="2">

                <Grid container spacing={1.4}>
                  <h1>Tab-2 {selectedTag.tag_number}</h1>
                </Grid>
              </TabPanel>
            </TabContext>
          </Box>

          {/* {load &&
        <VscSettingsGear className='rload'/>
        } */}
          <ConfigDetGrid selectedTag={selectedTag} />
        </div>
      </div>
    </>
  )
}

export default ConfigDetails;